import { render, staticRenderFns } from "./CustomerInfoAddNew.vue?vue&type=template&id=4b567964&scoped=true&"
import script from "./CustomerInfoAddNew.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoAddNew.vue?vue&type=style&index=0&id=4b567964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b567964",
  null
  
)

export default component.exports